export const WKI_SESSION_COOKIE_NAME = "WKISESSION";
export const WKI_TICKET_COOKIE_NAME = "WKITICKET";
export const HOST_WKI_TICKET_COOKIE_NAME = "_Host-WKITICKET";
export const TMP_WKI_TICKET_COOKIE_NAME = "WKI-SSO-TICKET";
export const PM_JUST_EXECUTED_COOKIE_NAME = "PassiveModeJustExecuted";
export const PM_EXECUTED_COOKIE_NAME = "PassiveModeExecuted";
export const PM_JUST_EXECUTED_EXPIRES_TIME = 30 * 1000 //in milliseconds
export const PM_EXECUTED_EXPIRES_TIME = 300 * 1000 //in milliseconds
export const HOST_WKI_TICKET_EXPIRES_TIME = 24 * 60 * 60 * 1000 //in milliseconds
export const SSO_LINK_LOGOUT = `${process.env.NEXT_PUBLIC_SSO_URL}?action=logout&redirect_url=${process.env.NEXT_PUBLIC_DOMAIN}/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}&fallback_url=${process.env.NEXT_PUBLIC_DOMAIN}/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}`;
